// extracted by mini-css-extract-plugin
module.exports = {"title":"_9e1425b4d3--title--kR_RE"};